import { BaseModel } from "../base-model";

export interface IPropertyChargeElementModel {
  DescEN: string;
  DescFR: string;
  DescNL: string;
  ElementId: number;
  GroupAmount: number;
  Id: number;
  ItemState: number;
  PropertyId: number;
  ParentId: number;
}
export class PropertyChargeElementModel extends BaseModel<IPropertyChargeElementModel>
  implements IPropertyChargeElementModel {
  DescEN: string;
  DescFR: string;
  DescNL: string;
  ElementId: number;
  GroupAmount: number;
  Id: number;
  ItemState: number;
  PropertyId: number;
  ParentId: number;
  /**
   *
   */
  constructor(option?: IPropertyChargeElementModel) {
    super(option);
  }
}
